import classNames from "classnames";
import { useState, useCallback, useEffect, useRef } from "react";
import { Col, Row, Button } from "react-bootstrap";
import { RootState } from "redux/store";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getGenericCategories } from "redux/slices/GenericCategories";
import { updatePreferredBrandField } from "redux/slices/PreferredBrands";
import { GenericCategoriesStocks } from "popups/GenericCategoriesStocks/GenericCategoriesStocks";
import { Table, CommonColumnProperties, ImportWizard } from "components";
import { ValidationState } from "components/ImportWizard/ImportWizardTypes";
import { getProducts } from "redux/slices/Products";
import { getPreferredBrandDetails } from "redux/slices/PreferredBrands";
import { runBatchWorkers } from "components/WebWorkers/ZWebWorker";
import axios from "axios";
import { getToken } from "helpers/api/authService";
import { PreferredBrandsImportWorkerData, PreferredBrandsImportWorkerResponseData } from "./preferredBrandsImportWorker";

export function Stock() {
    const dispatch = useAppDispatch();
    const [selectedId, setSelectedId] = useState<any>(0);
    const genericCategoryTableRef = useRef<any>(null);
    const [showPopup, setShowPopup] = useState(false);
    const [importWizardPopup, setImportWizardPopup] = useState(false);
    const [importPercentage, setImportPercentage] = useState<number>(0);
    const [genericCategoriesloading, setGenericCategoriesLoading] = useState(false);
    const [genericCategoriesStock, setGenericCategoriesStock] = useState<any[]>([]);
    const preferredBrands = useAppSelector((state: RootState) => state.preferredBrands);
    const genericCategories = useAppSelector((state: RootState) => state.genericCategories);
    const user = useAppSelector((state: RootState) => state.logedinUser);

    const columns = [
        {
            Header: "Generic Category",
            accessor: "genericCategoryName",
            width: 800,
            Cell: (row: any) => {
                const id: number = parseInt(row.cell.row.id);
                return (
                    <div className={classNames("ps-1", "pe-3", id === selectedId ? "selected-cell" : "deselected-cell")}
                        onClick={() => {
                            setSelectedId(id);
                            handleUpdate("selectedGenericCategory", row.cell.row.original.genericCategoryId);
                        }}
                    >{row.value}</div>
                );
            },
        },
        {
            Header: "No. of Lines",
            accessor: "stockCount",
            width: 120,
            Cell: (row: any) => {
                return <div style={{ paddingTop: "4px" }}>{row.cell.row.original.stocks.length}</div>;
            }
        }
    ];
    const columns2 = [
        {
            Header: "Rank",
            accessor: "rank",
            width: 100,
            Cell: (row: any) => {
                const id: number = parseInt(row.cell.row.id);
                const idPlus: number = parseInt(row.cell.row.id) + 1;
                return (<div className="d-flex">
                    <div className="ps-1 pe-3">{idPlus}</div>
                    <div className="rank-actions">
                        {/* @ts-ignore */}
                        {id < genericCategoriesStock.length - 1 ? (
                            <Button variant="light" className="btn-icon me-1 table-action-btn" onClick={() => moveStockDown(id)}>
                                <i className="uil-arrow-down"></i>
                            </Button>
                        ) : null}
                        {id > 0 ? (
                            <Button variant="light" className="btn-icon me-1 table-action-btn" onClick={() => moveStockUp(id)}>
                                <i className="uil-arrow-up"></i>
                            </Button>
                        ) : (
                            <Button variant="light" className="btn-icon me-1 table-action-btn" style={{ opacity: 0 }} disabled>
                                <i className="uil-arrow-up"></i>
                            </Button>
                        )}
                    </div>
                </div>
                );
            }
        },
        {
            Header: "Name",
            accessor: "name",
            width: 800,
        },
    ];

    useEffect(() => {
        if (preferredBrands.preferredStock.length > 0) {
            if(selectedId >= 0) {
            // @ts-ignore
            setGenericCategoriesStock(preferredBrands.preferredStock[selectedId].stocks);
            } else {
                setGenericCategoriesStock([]);
            }
        }
    }, [preferredBrands.preferredStock, selectedId]);

    useEffect(() => {
        dispatch(getGenericCategories({})).then((res) => {
            handleUpdate("mainGenericCategoriesTable", res.data);
            if (preferredBrands.stock.length > 0) genericCategoriesDataProsess();
            setGenericCategoriesLoading(true);
        });
    }, []);

    useEffect(() => {
        genericCategoriesDataProsess();
    }, [preferredBrands.stock, genericCategoriesloading]);

    useEffect(() => {
        if (preferredBrands.loading) setGenericCategoriesStock([]);
    }, [preferredBrands.loading]);

    function genericCategoriesDataProsess() {
        // Making the Generic Categories Names
        if (preferredBrands.mainGenericCategoriesTable.length > 0 && preferredBrands.stock.length > 0) {
            const genericCategoriesTable: any[] = [];
            const genericCategoryIdList: any[] = [...preferredBrands.stock.map((item: any) => item.genericCategoryId)];
            genericCategoryIdList.forEach((item: any) => {
                const genericCategoryItem: any = preferredBrands.mainGenericCategoriesTable.find((category: any) => category.id === item);
                const genericCategoryItemIndex: number = genericCategoriesTable.findIndex((category: any) => category.genericCategoryId === item);
                if (genericCategoryItem && genericCategoryItemIndex === -1) {
                    genericCategoriesTable.push({
                        genericCategoryId: item,
                        genericCategoryName: `${genericCategoryItem.fullName}`,
                        stocks: [
                            ...preferredBrands.stock.filter((stock: any) => stock.genericCategoryId === item),
                        ],
                    });
                }
            });
            handleUpdate("preferredStock", genericCategoriesTable.sort((a, b) => a.genericCategoryName.localeCompare(b.genericCategoryName)));
        }
    }

    async function genericCategoriesOnSave() {
        let selectedGenericCategories: any[] = [...genericCategories.selectedgenericCategoriesStock];
        let genericCategoriesList: any[] = [...preferredBrands.stock];
        const genericCategoriesStock: any[] = [...preferredBrands.stock.map((item: any) => item.productId)];
        selectedGenericCategories.forEach((item: any) => {
            const currentItem: any = genericCategories.stockList[item];
            if (!genericCategoriesStock.includes(currentItem.id)) {
                genericCategoriesList.push({
                    productId: currentItem.id,
                    rank: 0,
                    genericCategoryId: currentItem.genericCategoryId,
                    name: currentItem.name,
                    dispenseName: currentItem.dispenseName,
                });
            }
        });
        handleUpdate("stock", genericCategoriesList)
        setShowPopup(false);
    }

    function moveStockUp(id: number) {
        const preferredStock = [...preferredBrands.preferredStock];
        // @ts-ignore
        let preferredStocklevel = [...preferredBrands.preferredStock[selectedId].stocks];
        const stock = preferredStocklevel[id];
        if (id > 0) {
            preferredStocklevel[id] = preferredStocklevel[id - 1];
            preferredStocklevel[id - 1] = stock;
        }
        //@ts-ignore
        preferredStock[selectedId] = { ...preferredStock[selectedId], stocks: [...preferredStocklevel] };
        handleUpdate("preferredStock", preferredStock);
    }

    function moveStockDown(id: number) {
        const preferredStock = [...preferredBrands.preferredStock];
        //@ts-ignore
        let preferredStocklevel = [...preferredBrands.preferredStock[selectedId].stocks];
        const stock = preferredStocklevel[id];
        if (id < preferredStocklevel.length - 1) {
            preferredStocklevel[id] = preferredStocklevel[id + 1];
            preferredStocklevel[id + 1] = stock;
        }
        //@ts-ignore
        preferredStock[selectedId] = { ...preferredStock[selectedId], stocks: [...preferredStocklevel] };
        handleUpdate("preferredStock", preferredStock);
    }

    function handleDelete() {
        let preferredBrandProductId: any = [];
        preferredBrands.selectedStocksRows.forEach((row: any) => {
            // @ts-ignore
            preferredBrandProductId.push(preferredBrands.preferredStock[selectedId].stocks[row].productId);
        });
        setSelectedId(0);
        let newPreferredStock: any = [];
        preferredBrands.preferredStock.forEach((preferredStock: any) => {
            let stocks: any = [];
            preferredStock.stocks.forEach((stock: any) => {
                if (!preferredBrandProductId.includes(stock.productId)) stocks.push(stock);
            });
            if (stocks.length > 0) newPreferredStock.push({
                genericCategoryId: preferredStock.genericCategoryId,
                genericCategoryName: preferredStock.genericCategoryName,
                stocks: stocks
            });
        });
        dispatch(getPreferredBrandDetails({ ids: [preferredBrands.id], loadDetails: ['Manufacturers', 'Stock', 'Stores']  })).then(() => {
            if (newPreferredStock.length === 0) setGenericCategoriesStock([]);
            handleUpdate("preferredStock", newPreferredStock);
        });
    }

    function handleDeleteCategory() {
        let preferredBrandGenericCategoryId: any = [];
        preferredBrands.selectedCategoryRows.forEach((row: any) => {
            // @ts-ignore
            preferredBrandGenericCategoryId.push(preferredBrands.preferredStock[row].genericCategoryId);
        });
        let newPreferredStock: any = [];
        if (preferredBrands.selectedCategoryRows.length !== preferredBrands.preferredStock.length) {
            preferredBrands.preferredStock.forEach((preferredStock: any) => {
                if (!preferredBrandGenericCategoryId.includes(preferredStock.genericCategoryId)) newPreferredStock.push(preferredStock);
            });
        }

        dispatch(getPreferredBrandDetails({ ids: [preferredBrands.id], loadDetails: ['Manufacturers', 'Stock', 'Stores']  })).then(() => {
            if (newPreferredStock.length === 0) setGenericCategoriesStock([]);
            handleUpdate("preferredStock", newPreferredStock);
        });
    }

    const selectedCategoryRows = useCallback((pageIndex: any) => {
        handleUpdate("selectedCategoryRows", pageIndex);
    }, []);

    function handleUpdate(key: string, value: any) {
        dispatch(updatePreferredBrandField({ key: key, value: value }));
    }

    const selectedRows = useCallback((pageIndex: any) => {
        handleUpdate("selectedStocksRows", pageIndex);
    }, []);

    const terminateWorkersRef = useRef<Function>();

    async function importPreferredBrands(rows: any) {
        let newStocks: any[] = [];

		const webWorkerData: PreferredBrandsImportWorkerData = {
			data: [...rows],
		};

		const errors: Map<string, string> = new Map<string, string>();

        let updatedValidLines: any[] = [];

        const { runWorkers, terminateWorkers } = runBatchWorkers<PreferredBrandsImportWorkerData, any, PreferredBrandsImportWorkerResponseData>({
            workerData: webWorkerData, 
            createWorker: () => new Worker(new URL('./preferredBrandsImportWorker.ts', import.meta.url)), 
            onWorkerResponse: async (event, responseContext, httpErrors, reject) => {
                if (!responseContext.response.data) {
                    if (httpErrors) {
                        const combinedError = httpErrors.join(", ");
                        // Now using this combined error, construct a { stockName, error } object for each stock and push it onto the errors array
                        responseContext.originalBatchData.forEach((r: any) => {
                            const errorEntry = errors.get(r.__name);
                            errors.set(r.__name ?? "", errorEntry ? errorEntry + ", " + combinedError : combinedError);
                        });
                    }
                } else {
                    updatedValidLines.push(responseContext.response.data.updatedValidLines); // Push the valid lines that the web worker updated into a list that we can then iterate over once all web workers are finished
                }
                
				setImportPercentage((prev) => Math.min(100, prev + ((1 / responseContext.numBatches) * 100)));
            }, 
            onWorkersFinished: async (_) => {
                // Once all web workers are done, we iterate over the newly updated valid lines and perform the necessary logic for getting the new stocks to then update the table with.
                let flattendedLines = updatedValidLines.flat();
                flattendedLines.forEach((stock: any) => {
                    const existingStock = preferredBrands.stock.find((item: any) => item.productId === stock.id);
                    if (!existingStock) {
                        if (stock.genericCategoryId === undefined || stock.genericCategoryId === null) {
                            const errorEntry = errors.get(stock.__name);
                            errors.set(stock.__name ?? "", errorEntry ? errorEntry + ", " + "No Generic Category" : "No Generic Category");
                        } else {
                            newStocks.push({
                                productId: stock.id,
                                rank: 0,
                                genericCategoryId: stock.genericCategoryId,
                                name: stock.__name,
                                dispenseName: stock.__name,
                            });
                        }
                    }
                });
                handleUpdate("stock", [...preferredBrands.stock, ...newStocks]);
                setImportPercentage(0); //Reset the import percentage
            }, 
            onWorkerError: (error, unprocessedData) => {
                unprocessedData.forEach(data => {
                    const errorEntry = errors.get(data.__name);
                    const errorMessage = error.message ?? "Unknown error occurred";
                    errors.set(data.__name ?? "", errorEntry ? errorEntry + ", " + errorMessage : errorMessage);
                })
		    }
        });

        terminateWorkersRef.current = terminateWorkers;
        
        await runWorkers;

        const returnErrors: { stockName: string, error: string }[] = [];

		errors.forEach((value: string, key: string) => {
			returnErrors.push({
				stockName: key,
				error: value,
			})
		});

		return [...returnErrors];
    }

    function WholeTableValidation(rows: CommonColumnProperties[]): CommonColumnProperties[] {
        let temp: CommonColumnProperties[] = [...rows];

        rows.forEach(row => {
            if (row.hasError === undefined || row.hasError === false) { //don"t bother validating bad rows

                if (row.__pde !== undefined && row.__pde !== null) {
                    var otherMatches = temp.filter(i => i.__pde === row.__pde && i !== row);
                    if (otherMatches.length > 0) {
                        row.message = "Duplicate PDE";
                        row.hasError = true;
                        row.validationState = ValidationState.Invalid;
                    }
                }
            }
        });

        return temp;
    }

    function onSearchClick(){
        setGenericCategoriesStock([]);
        setSelectedId(-1);
    }

    return (
        <div className="set-search-with">
            <GenericCategoriesStocks show={showPopup} onClose={() => setShowPopup(false)} onSave={genericCategoriesOnSave} />
            <Row>
                <Col lg={6}>
                    <Table
                        pageSize={100}
                        isSortable={true}
                        maxHeight={450}
                        pagination={true}
                        isSelectable={true}
                        isSearchable={true}
                        disableExport={true}
                        columns={columns}
                        loading={preferredBrands.loading}
                        removeRows={handleDeleteCategory}
                        data={preferredBrands.preferredStock}
                        selectedRows={selectedCategoryRows}
                        addNewRow={() => setShowPopup(true)}
                        onSearchClick={onSearchClick}
                        className="preferred-brand-category-table table-text-uppercase"
                        reloadTableRows={() => dispatch(getPreferredBrandDetails({ ids: [preferredBrands.id], loadDetails: ['Manufacturers', 'Stock', 'Stores']  }))}
                    />
                </Col>
                <Col lg={6}>
                    <ImportWizard
                        title="Preferred Brands"
                        matchAgainst="Products"
                        display={importWizardPopup}
                        importAsync={(i) => importPreferredBrands(i)}
                        validateTable={(rows) => WholeTableValidation(rows)}
                        handleClose={() => { 
                            if (terminateWorkersRef.current) terminateWorkersRef.current();
                            setImportWizardPopup(false);
                        }}
                        finish={() => setImportWizardPopup(false)}
                        importPercentage={importPercentage}
                    />
                    <Table
                        pageSize={15}
                        isSortable={true}
                        maxHeight={450}
                        pagination={true}
                        isSelectable={true}
                        isSearchable={true}
                        disableExport={true}
                        columns={columns2}
                        removeRows={handleDelete}
                        selectedRows={selectedRows}
                        data={genericCategoriesStock}
                        loading={preferredBrands.loading}
                        className="preferred-brand-stocks-table"
                        singleImport={user.permissions.preferredBrands.canImport ? () => setImportWizardPopup(true) : undefined}
                        reloadTableRows={() => dispatch(getPreferredBrandDetails({ ids: [preferredBrands.id], loadDetails: ['Manufacturers', 'Stock', 'Stores']  }))}
                    />
                </Col>
            </Row>
        </div>
    );
}